export const formatDateFieldValue = (
  prevValue: string,
  value: string,
  selectedField: 'day' | 'month' | 'year'
): string => {
  const isYear = selectedField === 'year';
  const isDay = selectedField === 'day';
  const isMonth = selectedField === 'month';

  let newValue =
    (prevValue.length === 2 && !isYear) || prevValue.length === 4 ? value : prevValue + value;

  // Add leading zero for single-digit days or months
  if (newValue.length === 1) {
    if ((isDay && Number(value) > 3) || (isMonth && Number(value) > 1)) {
      newValue = '0' + newValue;
    }
  }

  // Cap the value for days and months
  if ((isDay || isMonth) && newValue.length === 2 && Number(newValue) === 0) {
    newValue = '01';
  }
  if (isDay && Number(newValue) > 31) {
    newValue = '31';
  } else if (isMonth && Number(newValue) > 12) {
    newValue = '12';
  }

  return newValue;
};

export function addSpecialCharacters(
  layout: Array<Array<string>>,
  rowIndex: number,
  arrayToInsert: Array<string>,
  insertIndex: number
): Array<Array<string>> {
  if (rowIndex < 0 || rowIndex >= layout.length) {
    throw new Error('Invalid row index');
  }
  const targetRow = [...layout[rowIndex]];
  const updatedLayout = [...layout];
  updatedLayout[rowIndex] = [
    ...targetRow.slice(0, insertIndex),
    ...arrayToInsert,
    ...targetRow.slice(insertIndex),
  ];
  return updatedLayout;
}
